import { Box, Stack, Typography } from '@mui/material';
import { type GetApprovalFlowInvoicesListResponse } from '@vy/api-definition';
import { INVOICE_REVIEW_STATUSES } from '@vy/types';
import type { ItemOf } from '@vy/utils';
import { ColorDot } from '../../../../components/design/ColorDot';
import { Price } from '../../../../components/design/Price';
import { ApprovedIcon } from '../../../../components/icons/ApprovedIcon';
import { LINE_ITEM_SIZE } from './ApprovalFlowInvoicesList';

type ApprovalFlowInvoicesListItemProps = {
  invoice: ItemOf<GetApprovalFlowInvoicesListResponse>;
  isSelected: boolean;
  onClick: (invoiceId: string) => void;
};

export const ApprovalFlowInvoicesListItem: React.FC<ApprovalFlowInvoicesListItemProps> = ({
  invoice,
  isSelected,
  onClick,
}) => {
  const isInvoiceApproved = invoice.reviewStatus === INVOICE_REVIEW_STATUSES.Approved;

  return (
    <Box
      className="group"
      onClick={() => onClick(invoice.invoiceId)}
      sx={{
        bgcolor: isSelected ? (theme) => theme.palette.action.selected : undefined,
        cursor: 'pointer',
        padding: '16px 12px 16px 12px',
        height: `${LINE_ITEM_SIZE}px`,

        '&:hover': {
          backgroundColor: (theme) => theme.palette.action.hover,
        }
      }}>
      <Stack direction="column" sx={{
        gap: 2
      }}>
        <Stack
          direction="row"
          sx={{
            paddingLeft: 0.5,
            justifyContent: "space-between"
          }}>
          <Stack direction="row" sx={{
            gap: 1
          }}>
            <div className="flex items-center justify-center w-6">
              {isInvoiceApproved && <ApprovedIcon className="h-4 w-6" />}
            </div>

            <Typography
              variant="body2"
              className="truncate"
              color={isInvoiceApproved ? 'text.secondary' : 'text.primary'}
            >
              {invoice.customerName}
            </Typography>
          </Stack>

          <Price
            variant="body2"
            color={invoice.revenueBreakdown.overage > 0 ? 'error.light' : 'text.secondary'}
            currency={invoice.currency}
          >
            {invoice.revenueBreakdown.total}
          </Price>
        </Stack>
        <Stack
          divider={isInvoiceApproved ? <ColorDot color="#768B99" sizeOverride="2px" /> : undefined}
          direction="row"
          sx={{
            gap: isInvoiceApproved ? 0 : 1,
            alignItems: "center"
          }}></Stack>
      </Stack>
    </Box>
  );
};
